module.exports = __webpack_public_path__ + "img/logo_image.76788d3d.svg";